import isEmpty from '../../utility/isEmpty'
import { AppBrands, KeyConstants, NavigationBrands, ServiceBrands } from '../../constants'

export default {
  userBrandCount (state) {
    return isEmpty(state.brands) ? 0 : Object.keys(state.brands).length
  },

  isCash1User () {
    return process.env.VUE_APP_AppBrand === AppBrands.c1l
  },

  isCaliforniaCheckCashUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.ccc
  },

  isCheckIntoCashUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.cic
  },

  isCheckSmartUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.chs
  },

  isCommunityChoiceUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.ccf
  },

  isEasyMoneyUser () {
    return process.env.VUE_APP_AppBrand === AppBrands.esm
  },

  isInstaLoanUser (state, getters) {
    return getters.userBrandCount > 0 && Object.keys(state.brands).includes(ServiceBrands.InstaLoan)
  },

  isTitleMaxUser (state, getters) {
    return getters.userBrandCount > 0 && Object.keys(state.brands).includes(ServiceBrands.TitleMax)
  },

  isCash1Available (state, getters) {
    return getters.isCash1User ? (state.brands[ServiceBrands.Cash1Loans].availableProviders || []).length > 0 : false
  },

  isCaliforniaCheckCashAvailable (state, getters) {
    return getters.isCaliforniaCheckCashUser ? (state.brands[ServiceBrands.CaliforniaCheckCash].availableProviders || []).length > 0 : false
  },

  isCheckIntoCashAvailable (state, getters) {
    return getters.isCheckIntoCashUser ? (state.brands[ServiceBrands.CheckIntoCash].availableProviders || []).length > 0 : false
  },

  isCheckSmartAvailable (state, getters) {
    return getters.isCheckSmartUser ? (state.brands[ServiceBrands.CheckSmart].availableProviders || []).length > 0 : false
  },

  isCommunityChoiceAvailable (state, getters) {
    return getters.isCommunityChoiceUser ? (state.brands[ServiceBrands.CommunityChoice].availableProviders || []).length > 0 : false
  },

  isEasyMoneyAvailable (state, getters) {
    return getters.isEasyMoneyUser ? (state.brands[ServiceBrands.EasyMoney].availableProviders || []).length > 0 : false
  },

  isInstaLoanAvailable (state, getters) {
    return getters.isInstaLoanUser ? (state.brands[ServiceBrands.InstaLoan].availableProviders || []).length > 0 : false
  },

  isTitleMaxAvailable (state, getters) {
    return getters.isTitleMaxUser ? (state.brands[ServiceBrands.TitleMax].availableProviders || []).length > 0 : false
  },

  hasAvailableProviders (state) {
    for (const brand of Object.keys(state.brands)) {
      if (!isEmpty(state.brands[brand].availableProviders)) {
        return true
      }
    }
    return false
  },

  hasOnlyInvictusProviders (state) {
    const allProviders = []

    for (const brand of Object.keys(state.brands)) {
      if (!isEmpty(state.brands[brand].providers)) {
        for (const provider of state.brands[brand].providers) {
          allProviders.push(provider)
        }
      }
    }

    return allProviders.includes(KeyConstants.lmsIds.Invictus) && !allProviders.includes(KeyConstants.lmsIds.TLXe) && !allProviders.includes(KeyConstants.lmsIds.NLS)
  },

  isTitleMaxLimited (state, getters) {
    return getters.isTitleMaxUser ? (state.brands[ServiceBrands.TitleMax].providers || []).length > (state.brands[ServiceBrands.TitleMax].availableProviders || []).length : false
  },

  /**
   * Returns the current brand to use for navigation, defaulting to TitleMax.
   * @returns {String} The navigation brand.
   */
  navigationBrand (state, getters) {
    if (getters.isCash1User) {
      return NavigationBrands.Cash1Loans
    } else if (getters.isCaliforniaCheckCashUser) {
      return NavigationBrands.CaliforniaCheckCash
    } else if (getters.isCheckSmartUser) {
      return NavigationBrands.CheckSmart
    } else if (getters.isCheckIntoCashUser) {
      return NavigationBrands.CheckIntoCash
    } else if (getters.isEasyMoneyUser) {
      return NavigationBrands.EasyMoney
    } else if (getters.isCommunityChoiceUser) {
      return NavigationBrands.CommunityChoice
    } else if (!getters.isTitleMaxUser && getters.isInstaLoanUser) {
      return NavigationBrands.InstaLoan
    } else {
      return NavigationBrands.TitleMax
    }
  },

  /**
   * Returns the current brand's external privacy policy URL.
   * @returns {String} The current brand's external privacy policy URL.
   */
  brandedPrivacyPolicyUrl (state, getters, rootState) {
    if (getters.isCash1User) {
      return rootState.session.c1lPrivacyPolicyUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return rootState.session.cccPrivacyPolicyUrl
    }

    if (getters.isCheckSmartUser) {
      return rootState.session.chsPrivacyPolicyUrl
    }

    if (getters.isCheckIntoCashUser) {
      return rootState.session.cicPrivacyPolicyUrl
    }

    if (getters.isCommunityChoiceUser) {
      return rootState.session.ccfPrivacyPolicyUrl
    }

    if (getters.isEasyMoneyUser) {
      return rootState.session.esmPrivacyPolicyUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return rootState.session.inlPrivacyPolicyUrl
    }

    return rootState.session.tmxPrivacyPolicyUrl
  },

  /**
   * Returns the current brand's external terms and conditions URL.
   * @returns {String} The current brand's external terms and conditions URL.
   */
  brandedTermsConditionsUrl (state, getters, rootState) {
    if (getters.isCash1User) {
      return rootState.session.c1lTermsConditionsUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return rootState.session.cccTermsConditionsUrl
    }

    if (getters.isCheckSmartUser) {
      return rootState.session.chsTermsConditionsUrl
    }

    if (getters.isCheckIntoCashUser) {
      return rootState.session.cicTermsConditionsUrl
    }

    if (getters.isCommunityChoiceUser) {
      return rootState.session.ccfTermsConditionsUrl
    }

    if (getters.isEasyMoneyUser) {
      return rootState.session.esmTermsConditionsUrl
    }
  },

  /**
   * Returns the current brand's store locator URL.
   * @returns {String} The current brand's store locator URL.
   */
  brandedStoreLocatorUrl (state, getters) {
    if (getters.isCash1User) {
      return process.env.VUE_APP_StoreLocatorC1lSiteUrl
    }

    if (getters.isCaliforniaCheckCashUser) {
      return process.env.VUE_APP_StoreLocatorCccSiteUrl
    }

    if (getters.isCheckSmartUser) {
      return process.env.VUE_APP_StoreLocatorChsSiteUrl
    }

    if (getters.isCheckIntoCashUser) {
      return process.env.VUE_APP_StoreLocatorCicSiteUrl
    }

    if (getters.isCommunityChoiceUser) {
      return process.env.VUE_APP_StoreLocatorCcfSiteUrl
    }

    if (getters.isEasyMoneyUser) {
      return process.env.VUE_APP_StoreLocatorEsmSiteUrl
    }

    if (getters.navigationBrand === NavigationBrands.InstaLoan) {
      return process.env.VUE_APP_StoreLocatorInlSiteUrl
    }

    return process.env.VUE_APP_StoreLocatorTmxSiteUrl
  }
}
